export default __webpack_public_path__ + "static/affiliate-program-PartnersAre-6-9a030fb563a960b8f6905990c9b09af7.svg";